<script setup lang="ts">
import type { MenuLink } from '@/components/Header/Header.types'

import { useResponsive } from '@shared/nuxt/useResponsive'

type Props = {
  isShowNavMenu: boolean
  menuLinks: MenuLink[]
}

type Emits = {
  (event: 'show-sidebar'): void
}

defineProps<Props>()

const emit = defineEmits<Emits>()

const { isDesktop } = useResponsive()
</script>

<template>
  <div class="header-menu" data-test-id="header-menu">
    <template v-if="isDesktop">
      <a
        v-for="link in menuLinks"
        :key="link.url"
        class="header-menu__item"
        :title="link.title"
        :href="link.url"
        target="_blank"
        data-test-id="menu-link"
      >
        {{ link.title }}
      </a>
    </template>

    <the-button
      v-else
      id="btnCloseCommonSidebar"
      variant="transparent"
      size="sm"
      icon-size="30"
      icon-color="var(--ui-color-supporting-01)"
      :icon="isShowNavMenu ? 'cancel' : 'menu'"
      data-test-id="menu-toggle-button"
      @click="emit('show-sidebar')"
    />
  </div>
</template>

<style scoped lang="scss">
.header-menu {
  display: flex;
  gap: 36px;

  &__item {
    font-size: 14px;
    font-weight: 600;
    color: var(--ui-color-supporting-01);
  }
}
</style>
